import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=da67fbc4&"
import script from "./icon.vue?vue&type=script&lang=ts&"
export * from "./icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports